import React, { useState, useEffect , useRef} from 'react';
import Banner from '../../Banner/Banner';
import parse from "html-react-parser";
import { Link } from 'react-router-dom';
import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';
const BASEURL = process.env.REACT_APP_SOMPROP_BASE_URL;

const SALONAPI = process.env.REACT_APP_SOMPROP_API_EXTERNAL;
const Demo = () => {

  
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [menu, setMenu] = useState(null);
    const [menuloading, setmenuloading] = useState(true);
    const [menuerror, setmenuerror] = useState(null)

    const [submenu, setsubmenu] = useState(null);
    const [submenuloading, setsubmenuloading] = useState(true);
    const [submenuerror, setsubmenuerror] = useState(null)
    
    const [filteredItems, setFilteredItems] = useState(null);
    const [activeTab, setActiveTab] = useState('All');
    const [displayCount, setDisplayCount] = useState(10);

    const gridRef = useRef(null);
    const iso = useRef(null);


  



    const handleViewMore = () => {
        setDisplayCount(prevCount => prevCount + 10);
    };

    const fetchData = async (url, setData, setLoading, setError) => {
      setLoading(true);
      setError(null);
    
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setData(data);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {

      fetchData( `${SALONAPI}/past_propertiesData`,
        setData,
        setLoading,
        setError
      );

      //Services Menu Data

      fetchData( `${SALONAPI}/currentPropertiesMenuData`,
        setMenu,
        setmenuloading,
        setmenuerror
      );

      
    }, []);


    useEffect(() => {
        
        const fetchAllSubMenus = async () => {
            if (menu && menu.length > 0) {
                setsubmenuloading(true);
                setsubmenuerror(null);
        
                try {
                    const allSubMenus = await Promise.all(
                        menu.map(async (menuItem) => {
                            const response = await fetch(`${SALONAPI}/currentPropertiesSubMenuData/${menuItem.menu_id}`);
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }
                            const submenuData = await response.json();
                            return submenuData;
                        })
                    );
        
                    const flatSubmenus = allSubMenus.flat();
                    setsubmenu(flatSubmenus);
                    setFilteredItems(flatSubmenus);
        
                } catch (error) {
                    setsubmenuerror(error);
                } finally {
                    setsubmenuloading(false);
                }
            }
        };
        fetchAllSubMenus()

    }, [menu]);

    
    
   
    
    const filterItems = (category) => {   
        if (category === 'All') {
            setFilteredItems(submenu)  
        } else {
            const filteredSubmenu = submenu.filter(item => item.menu_title && item.menu_title?.toLowerCase().split(' ').join('') === category);
            setFilteredItems(filteredSubmenu);
            setDisplayCount(10)
        }
        setActiveTab(category);
      };

      useEffect(() => {
        if (gridRef.current) {
          imagesLoaded(gridRef.current, () => {
            if (iso.current) {
              iso.current.reloadItems();
              iso.current.arrange();
            } else {
              iso.current = new Isotope(gridRef.current, {
                itemSelector: '.grid-item',
                layoutMode: 'fitRows',
                transitionDuration: '0.8s'
              });
            }
          });
        }
      }, [filteredItems]);

  let placeHolderImg = `${BASEURL}/images/placeholder.jpg`

    if (error) return <p>Error: {error.message}</p>;
    if(menuerror) return <p>Error : {menuerror.message}</p>
    if(submenuerror) return <p>Error : {submenuerror.message}</p>




  return (
    <React.Fragment>
       <Banner />
       <main className="current-properties-section past-properties-sec">
       <div className="container">
          <div className="row">
            <div className="col-md-12 col-12">
            {loading ? (
                <div className="shimmer-main" style={{ maxWidth: '1125px', width: '100%', margin: '78px auto' }}>
                  <div className="shimmer" style={{ minHeight: '25px', display: 'block', marginBottom: '20px', borderRadius: '5px', width: '400px' }}></div>
                  <div className="shimmer" style={{ minHeight: '18px', display: 'block', marginBottom: '16px', borderRadius: '5px', width: '100%' }}></div>
                  <div className="shimmer" style={{ minHeight: '18px', display: 'block', marginBottom: '16px', borderRadius: '5px', width: '95%' }}></div>
                  <div className="shimmer" style={{ minHeight: '18px', display: 'block', marginBottom: '16px', borderRadius: '5px', width: '90%' }}></div>
                  <div className="shimmer" style={{ minHeight: '18px', display: 'block', marginBottom: '16px', borderRadius: '5px', width: '70%' }}></div>
                  <div className="shimmer" style={{ minHeight: '18px', display: 'block', marginBottom: '16px', borderRadius: '5px', width: '40%' }}></div>
                </div>
              ) : (
                <div className="our-market-mx">
                  {data && parse(data.website_settings.past_properties && (data.website_settings.past_properties || ''))}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="current-properties-section past-properties-sec" >
            <div className='container'>
            <h3>Current Properties</h3>

            <div className="text-center filtering">
             {
                !menuloading && (<button className={`btn btn-default filter-button ${activeTab === 'All' ? 'active' : ''}`}  onClick={() => filterItems('All')}>
                <span><img src="images/maps/all-current-properties-icon.svg" width="57" height="36" alt="current properties icon img"/></span> 
                All Current Properties
               </button>)
             }
              
              {
                menu && menu.map((menu) => {
                // let menuTitleLowercase = 
                  // console.log(menu.menu_title === activeTab)
                  return(
                    <button className={`btn btn-default filter-button ${activeTab === menu.menu_title.toLowerCase().split(' ').join('') && menu.menu_title.toLowerCase().split(' ').join('') ? 'active' : ''}`} key={menu.menu_id} onClick={() => filterItems(menu.menu_title.toLowerCase().split(' ').join(''))}  >
                      <span>
                        <img src={menu.menu_attachment} width="40" height="38" alt={menu.menu_title}/>
                      </span>    
                    {menu.menu_title}
                </button>
                  )
                })
              }

                
            </div> 
            <div className="current-properties-gird">  
                <div className="row gallery-gird grid gallery " >

                    {
                        !submenuloading ? (
                           
                            filteredItems.length > 0 ? (  filteredItems && filteredItems.slice(0, displayCount).map((filterItem) => (
                            
                                <div className="col-lg-3 col-md-3 col-sm-6 col-12 grid-item hdpe" ref={gridRef} key={filterItem.sub_menu_id}>
                                    <Link to={`/current-properties/${filterItem.sub_menu_title.toLowerCase().replace(/,/g, '').split(' ').join('-')}-${filterItem.sub_menu_id}`}>
                                     <div className="current-properties-box">
                                        <div className="current-properties-img">
                                            <img src={filterItem.sub_menu_file || placeHolderImg} width="239" height="239" alt={filterItem.sub_menu_title} />
                                        </div>
                                        <div className="current-properties-content">
                                            <h4>{filterItem.sub_menu_title}</h4>
                                            <p>{parse(filterItem.sub_menu_description)}</p>
                                            <p><span>{filterItem.sub_menu_price}</span></p>
                                        </div>
                                    </div>
                                    </Link>
                               </div>
                               
                            ))) : (<div className='coming-soon shimmer' style={{display:'flex'}}><p>Coming Soon..</p></div>)

                           

                        ) : (<div className="shimmer-main row" style={{ maxWidth: '1100px', width: '100%', margin: '25px auto', justifyContent: 'center',flexWrap:'wrap' }}>
                            <div className="shimmer" style={{ width: '22%', height: '250px', display: 'block', marginRight: '15px',marginBottom:'15px' }}></div>
                            <div className="shimmer" style={{ width: '22%', height: '250px', display: 'block', marginRight: '15px', marginBottom:'15px' }}></div>
                            <div className="shimmer" style={{ width: '22%', height: '250px', display: 'block', marginRight: '15px', marginBottom:'15px' }}></div>
                            <div className="shimmer" style={{ width: '22%', height: '250px', display: 'block', marginRight: '15px',marginBottom:'15px' }}></div>

                            <div className="shimmer" style={{ width: '22%', height: '250px', display: 'block', marginRight: '15px',marginBottom:'15px' }}></div>
                            <div className="shimmer" style={{ width: '22%', height: '250px', display: 'block', marginRight: '15px', marginBottom:'15px' }}></div>
                            <div className="shimmer" style={{ width: '22%', height: '250px', display: 'block', marginRight: '15px', marginBottom:'15px' }}></div>
                            <div className="shimmer" style={{ width: '22%', height: '250px', display: 'block', marginRight: '15px',marginBottom:'15px' }}></div>

                            
                            
                          </div>)
                    }
                   
                   

                </div>
              
                {filteredItems && filteredItems.length > displayCount ? <div className="view-more-btn">
                    <button type='button' className="btn btn-green" onClick={handleViewMore}>View More</button>
               </div> : null}

                
               
                
                
                
            </div>
            </div>
        </div>
       

       </main>
    </React.Fragment>
  )
}

export default Demo
